<script setup lang="ts">
export type BcLoadingTextProps = { loadingText?: string };

const { loadingText = "Loading data" } = defineProps<BcLoadingTextProps>();
</script>

<template>
  <div class="bissantzControls loadingBox">
    <span class="loading"
      ><slot>{{ loadingText }}</slot></span
    >
    <span class="one">.</span>
    <span class="two">.</span>
    <span class="three">.</span>
  </div>
</template>

<style lang="less">
@import "../styles/components/bc-loading-text.less";
</style>
